import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../services/userService";
import { ResponseError } from "../../../objects/common/responseError";
import "../../../common/helpers/stringHelper";
import { RegisterModel } from "../../../objects/users/registerModel";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfigService } from "../../../services/configService";
import { CookieService } from "ng2-cookies";

@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    moduleId: module.id.toString()
})
export class RegisterComponent implements OnInit {
    public model: RegisterModel;
    public block: boolean;
    public processing: boolean;
    public errors: Array<ResponseError> = [];

    constructor(private userService: UserService,
                private cookieService: CookieService,
                private configService: ConfigService,
                private router: Router,
                private route: ActivatedRoute) { }

    ngOnInit(): void {
        let userId = this.route.snapshot.queryParams['userId'] || '';

        this.model = new RegisterModel();

        if(!String.isNullOrEmpty(userId)){
            this.block = true;

            this.userService.getUserInfo(userId).then(response => {
                let user = response.Data;

                this.model.Email = user.Email;
                this.model.FirstName = user.FirstName;
                this.model.LastName = user.LastName;
            })
        }
    }

    public register(isValid: boolean): void {
        this.errors = [];

        if (!isValid)
            return;

        this.processing = true;
        this.userService.register(this.model).then(response => {
            let returnUrl = response.Data.ReturnUrl;
            this.userService.login(this.model.Email, this.model.Password).then(x => {
                const response = x.json();
                this.cookieService.set(this.configService.config.ApiTokenCookieName, response.access_token);
                this.cookieService.set(this.configService.config.UserCookieName, response.userID);

                this.router.navigate([returnUrl]);
            }).catch(x => {
                this.processing = false;

                this.errors.push({
                    Key: "",
                    Value: [x.json().error_description]
                })
            });
        }).catch(response => {
            this.processing = false;
            this.errors = this.errors.concat(response.Errors);
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/auth/register/register.component.ts